export const validateField = (fieldName, value, allFields, t) => {
	let errorMsg = "";

	const horasMaximas = allFields[t("lab_tool.contract.labels.cotsup")];
	const horasMinimas = allFields[t("lab_tool.contract.labels.cotinf")];

	const diasMaximos = allFields[t("lab_tool.contract.labels.dias_lab_maximos")];
	const diasMinimos = allFields[t("lab_tool.contract.labels.dias_lab_minimos")];

	const contratoExtraValue = allFields[t("lab_tool.contract.labels.contrato_extra")];

	const numValue = parseFloat(value);
	const isInteger = Number.isInteger(numValue);

	if (
		!value &&
		!(fieldName === t("lab_tool.contract.labels.meses_contrato") && contratoExtraValue !== "true")
	) {
		errorMsg = `${fieldName} ${t("aux.is_obligatory")}`;
	} else {
		switch (fieldName) {
			case t("lab_tool.contract.labels.nombre"):
				if (value.length < 3) {
					errorMsg = t("lab_tool.contract.val_con.nombre.minLength");
				} else if (/^\d+$/.test(value)) {
					errorMsg = t("lab_tool.contract.val_con.nombre.invalid");
				}
				break;

			case t("lab_tool.contract.labels.kronos_name"):
				if (value.length < 3) {
					errorMsg = t("lab_tool.contract.val_con.nombre.minLength");
				} else if (/^\d+$/.test(value)) {
					errorMsg = t("lab_tool.contract.val_con.nombre.invalid");
				}
				break;

			default:
				if (isNaN(numValue) || /[a-zA-Z]/.test(value) || numValue < 0) {
					errorMsg = t("lab_tool.contract.val_con.generic.invalid_number");
				} else {
					const integerFields = [
						t("lab_tool.contract.labels.zcero"),
						t("lab_tool.contract.labels.meses_contrato"),
						t("lab_tool.contract.labels.dias_lab_maximos"),
						t("lab_tool.contract.labels.dias_lab_minimos"),
					];
					if (integerFields.includes(fieldName) && !isInteger) {
						errorMsg = t("lab_tool.contract.val_con.generic.must_be_integer");
					}

					switch (fieldName) {
						case t("lab_tool.contract.labels.productividad"):
							if (numValue > 5) {
								errorMsg = t("lab_tool.contract.val_con.productividad.range");
							}
							break;

						case t("lab_tool.contract.labels.rotacion"):
						case t("lab_tool.contract.labels.ausentismo"):
							if (numValue > 1) {
								errorMsg = t("lab_tool.contract.val_con.rotacion.range");
							}
							break;

						case t("lab_tool.contract.labels.cotsup"):
							if (numValue > 24) {
								errorMsg = t("lab_tool.contract.val_con.cotsup.range");
							} else if (horasMinimas && numValue < parseFloat(horasMinimas)) {
								errorMsg = t("lab_tool.contract.val_con.cotsup.minMaxMismatch");
							}
							break;

						case t("lab_tool.contract.labels.cotinf"):
							if (horasMaximas && numValue > parseFloat(horasMaximas)) {
								errorMsg = t("lab_tool.contract.val_con.cotinf.minMaxMismatch");
							}
							break;

						case t("lab_tool.contract.labels.dias_lab_maximos"):
							if (numValue > 7) {
								errorMsg = t("lab_tool.contract.val_con.dias_lab_maximos.range");
							} else if (diasMinimos && numValue < parseFloat(diasMinimos)) {
								errorMsg = t("lab_tool.contract.val_con.dias_lab_maximos.minMaxMismatch");
							}
							break;

						case t("lab_tool.contract.labels.dias_lab_minimos"):
							if (diasMaximos && numValue > parseFloat(diasMaximos)) {
								errorMsg = t("lab_tool.contract.val_con.dias_lab_minimos.minMaxMismatch");
							}
							break;

						case t("lab_tool.contract.labels.hora_contrato"):
							if (numValue > 168) {
								errorMsg = t("lab_tool.contract.val_con.hora_contrato.range");
							}
							break;

						case t("lab_tool.contract.labels.meses_contrato"):
							if (contratoExtraValue === "true" && (numValue < 1 || numValue > 12)) {
								errorMsg = t("lab_tool.contract.val_con.meses_contrato.range");
							}
							break;

						default:
							break;
					}
				}
				break;
		}
	}

	return errorMsg;
};

export const validateFieldSite = (fieldName, value, allFields, t) => {
	let errorMsg = "";
	if (!value) {
		errorMsg = `${fieldName} ${t("aux.is_obligatory")}`;
	} else {
		switch (fieldName) {
			case t("lab_tool.site.labels.nombre"):
				if (value.length < 3) {
					errorMsg = t("lab_tool.site.val_site.nombre.minLength");
				} else if (/^\d+$/.test(value)) {
					errorMsg = t("lab_tool.site.val_site.nombre.invalid");
				}
				break;
			case t("lab_tool.site.labels.opmin"):
				if (isNaN(value) || value < 0) {
					errorMsg = t("lab_tool.site.val_site.opmin.positive");
				}
				break;
			case t("lab_tool.site.labels.cu"):
				if (isNaN(value) || value < 0) {
					errorMsg = t("lab_tool.site.val_site.cu.positive");
				}
				break;
			case t("lab_tool.site.labels.co"):
				if (isNaN(value) || value < 0) {
					errorMsg = t("lab_tool.site.val_site.co.positive");
				}
				break;
			case t("lab_tool.site.labels.slmin"):
				if (isNaN(value) || value < 0 || value > 5) {
					errorMsg = t("lab_tool.site.val_site.slmin.range");
				}
				break;
			default:
				break;
		}
	}
	return errorMsg;
};
